const REGIONAL_INDICATOR_OFFSET = 127397;

/**
 * Convert a 2-letter ISO 3166-1 alpha-2 country code (e.g. 'GB') into its flag emoji
 */
export const countryCodeToFlagEmoji = (code: string): string =>
  code
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET));

/**
 * Get the supporter country select field, if present on the page
 */
export const getCountryField = (): HTMLInputElement | HTMLSelectElement | undefined => {
  const countryField = document.querySelector('[name="supporter.country"]');

  return (countryField as HTMLInputElement | HTMLSelectElement) || undefined;
};
